// VINValidator/index.mjs

import { loading } from 'commonAssets/js/constants';
import { loadingGif, modal } from 'commonAssets/js/helpers';

const showLoading = () => loadingGif(loading, 'show');
const hideLoading = () => loadingGif(loading, 'hide');
const showError = (message) => modal('Error', message);

export class VINValidator {
    constructor(input, button) {
        this.input = input;
        this.button = button;
    }

    validate() {
        if (this.input.value === '' || this.input.value.length < 17) {
            this.input.classList.add('is-invalid');
            this.button.innerHTML = 'Check VIN';
            hideLoading();
            showError('Please enter a valid VIN number.');
            return false;
        }
        this.input.classList.add('is-valid');
        return true;
    }
}
